/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Backdoor to skip Graphql type definition and resolvers */
  JSON: any;
  /** Custom scalar type to represent preference values */
  PreferenceValue: any;
};

export type AddPreferenceOutput = {
  __typename?: 'AddPreferenceOutput';
  /** The updated item */
  item?: Maybe<PreferenceDefinition>;
  /** Updated list of preferences */
  preferences?: Maybe<Array<Maybe<PreferenceInstance>>>;
  /** Whether the mutation was successful */
  status: Scalars['Boolean'];
};

export type AddPreferenceOutputPreferencesArgs = {
  input?: InputMaybe<PreferenceQueryInput>;
};

export type ClearPreferenceInput = {
  /** Preference ID. Must match the ID of a preference definition */
  id: Scalars['ID'];
  /** When the preference applies. Must be equal to or lower than the protection scope of the preference. */
  scope: PreferenceLevel;
  /** The target of the preference */
  target: Scalars['ID'];
};

export type ClearSystemPreferenceInput = {
  /** Preference ID. Must match the ID of a preference definition */
  id: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Define a new preference. If preference with same name already exists error will be thrown. */
  addPreferenceDefinition?: Maybe<AddPreferenceOutput>;
  /** Clear a preference value */
  clearPreference?: Maybe<SetPreferenceOutput>;
  /** Clear a system preference value */
  clearSystemPreference?: Maybe<SetPreferenceOutput>;
  /** Set a preference value */
  setPreference?: Maybe<SetPreferenceOutput>;
  /** Set a system preference that will apply to multiple applications */
  setSystemPreference?: Maybe<SetPreferenceOutput>;
};

export type MutationAddPreferenceDefinitionArgs = {
  input: PreferenceDefinitionInput;
};

export type MutationClearPreferenceArgs = {
  input: ClearPreferenceInput;
};

export type MutationClearSystemPreferenceArgs = {
  input: ClearSystemPreferenceInput;
};

export type MutationSetPreferenceArgs = {
  input: PreferenceInstanceInput;
};

export type MutationSetSystemPreferenceArgs = {
  input: SystemPreferenceInput;
};

export type PreferenceDefinition = {
  __typename?: 'PreferenceDefinition';
  /** Preference description */
  description?: Maybe<Scalars['String']>;
  /** Preference ID. Must be unique across all applications. */
  id: Scalars['ID'];
  /**
   * The lowest level that is able to modify this preference.
   *
   * For example a user would be able to modify preferences with protection scope="user" but not preferences with protection scope="application"
   */
  protectionScope: PreferenceLevel;
  /** Preference type */
  type: PreferenceType;
};

export type PreferenceDefinitionInput = {
  /** Preference description */
  description?: InputMaybe<Scalars['String']>;
  /** Preference ID. Must be unique across all applications. */
  id: Scalars['ID'];
  /**
   * The lowest level that is able to modify this preference.
   *
   * For example a user would be able to modify preferences with protection scope="user" but not preferences with protection scope="application"
   */
  protectionScope: PreferenceLevel;
  /** Preference type */
  type: PreferenceType;
};

export type PreferenceInstance = {
  __typename?: 'PreferenceInstance';
  /** Preference name. Must match the ID of a preference definition */
  name: Scalars['ID'];
  /** When the preference applies. Must be equal to or lower than the protection scope of the preference. */
  scope: PreferenceLevel;
  /** The target of the preference. Null for system preferences. */
  target?: Maybe<Scalars['ID']>;
  /** Preference value */
  value: Scalars['PreferenceValue'];
};

export type PreferenceInstanceInput = {
  /** Preference ID. Must match the ID of a preference definition */
  id: Scalars['ID'];
  /** When the preference applies. Must be equal to or lower than the protection scope of the preference. */
  scope: PreferenceLevel;
  /** The target of the preference */
  target: Scalars['ID'];
  /** Preference value */
  value: Scalars['PreferenceValue'];
};

/** Currently supported preverence levels */
export enum PreferenceLevel {
  Account = 'ACCOUNT',
  AccountGroup = 'ACCOUNT_GROUP',
  AccountRollup = 'ACCOUNT_ROLLUP',
  Application = 'APPLICATION',
  System = 'SYSTEM',
  User = 'USER'
}

export type PreferenceQueryInput = {
  /** Account (seller number) */
  account?: InputMaybe<Scalars['String']>;
  /** Account group (group of seller numbers) */
  accountGroup?: InputMaybe<Scalars['String']>;
  /** Account rollup (group of account groups) */
  accountRollup?: InputMaybe<Scalars['String']>;
  /** Application loading the preference. Defaults to "sd". */
  application?: InputMaybe<Scalars['String']>;
  /** User */
  username?: InputMaybe<Scalars['String']>;
};

/** Currently supported preference types */
export enum PreferenceType {
  Boolean = 'BOOLEAN',
  BooleanArray = 'BOOLEAN_ARRAY',
  Number = 'NUMBER',
  NumberArray = 'NUMBER_ARRAY',
  Range = 'RANGE',
  RangeArray = 'RANGE_ARRAY',
  String = 'STRING',
  StringArray = 'STRING_ARRAY'
}

export type Query = {
  __typename?: 'Query';
  /** Get current preferences for multiple combinations */
  bulkPreferences?: Maybe<Array<Maybe<Array<Maybe<PreferenceInstance>>>>>;
  /** Get the definition for a specific preference */
  definition?: Maybe<PreferenceDefinition>;
  /** Get a list of all defined preferences */
  definitions?: Maybe<Array<Maybe<PreferenceDefinition>>>;
  /** Get current preferences */
  preferences?: Maybe<Array<Maybe<PreferenceInstance>>>;
};

export type QueryBulkPreferencesArgs = {
  input: Array<PreferenceQueryInput>;
};

export type QueryDefinitionArgs = {
  id: Scalars['ID'];
};

export type QueryPreferencesArgs = {
  input: PreferenceQueryInput;
};

export type SetPreferenceOutput = {
  __typename?: 'SetPreferenceOutput';
  /** The updated item */
  item?: Maybe<PreferenceInstance>;
  /** Updated list of preferences */
  preferences?: Maybe<Array<Maybe<PreferenceInstance>>>;
  /** Whether the mutation was successful */
  status: Scalars['Boolean'];
};

export type SetPreferenceOutputPreferencesArgs = {
  input: PreferenceQueryInput;
};

export type SystemPreferenceInput = {
  /** Preference ID. Must match the ID of a preference definition */
  id: Scalars['ID'];
  /** Preference value */
  value: Scalars['PreferenceValue'];
};
